module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"cliente":"Cliente","otros":"Otros"}}')
  delete Component.options._Ctor
}
